export default "__VITE_PUBLIC_ASSET__ec82453a__"